// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__4wvvW","fake":"Sidebar_fake__m8ed7"};